// import * as types from '../types';
import { ActionContext, ActionTree, GetterTree } from "vuex";
import { InspectionItem } from "@/model/InspectionSeibi";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import { INSPECT_TYPE } from "@/model/InspectType";
import { DO_SEIBI } from "@/model/DoSeibi";

export interface InspectionState {
  inspect: InspectionItem[][];
  hasData: boolean;
}
const initialState: InspectionState = {
  inspect: [[], [], []],
  hasData: false
};

const actions: ActionTree<InspectionState, any> = {
  setSeibiData(
    { commit }: ActionContext<InspectionState, any>,
    payload: any
  ): void {
    commit("setSeibiData", payload);
  },
  updateInspect(
    { commit }: ActionContext<InspectionState, any>,
    payload: InspectionItem
  ): void {
    commit("updateInspect", payload);
  },
  updateDoTenken(
    { commit }: ActionContext<InspectionState, any>,
    payload: InspectionItem
  ): void {
    commit("updateDoTenken", payload);
  },
  confirm(
    { commit }: ActionContext<InspectionState, any>,
    payload: { type: number; value: number }
  ): void {
    commit("confirm", payload);
  },
  clearState({ commit }: ActionContext<InspectionState, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setSeibiData(state: InspectionState, payload: any) {
    let items: any = Object.values(payload);
    // if (items.length > 3) {
    //   items = items.slice(0, 3);
    // }
    state.inspect = [...items];
    // if (payload.manualItems && payload.manualItems[2].length > 0) {
    //   state.manualItems = payload.manualItems[2];
    // }
    state.hasData = true;
  },
  updateInspect(state: InspectionState, payload: InspectionItem) {
    updateInspect(state, payload, false);
  },
  updateDoTenken(state: InspectionState, payload: InspectionItem) {
    updateInspect(state, payload, true);
  },
  clearState(state: InspectionState) {
    Object.assign(state, { ...initialState });
  }
};

const getters: GetterTree<InspectionState, any> = {
  getSeibiData(state: InspectionState) {
    return [...state.inspect];
  },
  hasData(state: InspectionState) {
    return state.hasData;
  },
  getByInspectResult: (state: InspectionState) => (
    inspectType: number,
    inspectResult: number
  ) => {
    let seibi = JSON.parse(JSON.stringify(state.inspect));
    let seibi1 = seibi[inspectType];
    if (seibi1 && seibi1.length > 0) {
      return seibi1.filter((item: InspectionItem) => {
        // 2022-01-31 morisako kobac-free mod [START]
        // if (item.inspectResult == inspectResult) {
        if (item.inspectResult == inspectResult && item.isDiscount != 1) {
        // 2022-01-31 morisako kobac-free mod [END]
          if(item.doTenken == 0){
            // if (inspectResult == InspectButtonValue.CROSS) {
            //   item.doTenken = DO_SEIBI.suru;
            // } else
            if(inspectResult == InspectButtonValue.CIRCLE) {
              item.doTenken = DO_SEIBI.shinai;
            }
          }
          return item;
        }
      });
    } else {
      return [];
    }
  },
  getByInspectDescriptionId: (state: InspectionState) => (
    sknInspectDescriptionId: string
  ) => {
    let seibi = JSON.parse(JSON.stringify(state.inspect));
    let foundSeibi = null;
    for (let i = 0; i < seibi.length; i++) {
      let seibi1 = seibi[i];
      if (seibi1 && seibi1.length > 0) {
        foundSeibi = seibi1.find(
          (item: InspectionItem) =>
            item.sknInspectDescriptionId == Number(sknInspectDescriptionId)
        );
        if (foundSeibi) {
          return {
            ...foundSeibi,
            kouchinZk: +foundSeibi.kouchinZk,
            buhinZk: +foundSeibi.buhinZk
          };
        }
      }
    }
    return null;
  },
  // 2022-01-31 morisako kobac-free add [START]
  getByIsDiscount: (state: InspectionState) => (
    inspectType: number,
    inspectResult: number
  ) => {
    let seibi = JSON.parse(JSON.stringify(state.inspect));
    let seibi1 = seibi[inspectType];
    if (seibi1 && seibi1.length > 0) {
      return seibi1.filter((item: InspectionItem) => {
        if (item.inspectResult == inspectResult && item.isDiscount == 1) {
          if(item.doTenken == 0){
            if(inspectResult == InspectButtonValue.CIRCLE) {
              item.doTenken = DO_SEIBI.shinai;
            }
          }
          return item;
        }
      });
    } else {
      return [];
    }
  },
  // 2022-01-31 morisako kobac-free add [END]
  listInspectAll: (state: InspectionState, getters) => {
    let _list: InspectionItem[][] = [];
    // 2022-01-31 morisako kobac-free add [START]
    let discountGenshaList1 = getters.getByIsDiscount(
      INSPECT_TYPE.GENSHA,
      InspectButtonValue.CIRCLE
    );
    let discountLegalList1 = getters.getByIsDiscount(
      INSPECT_TYPE.LEGAL56,
      InspectButtonValue.CIRCLE
    );
    // 2022-01-31 morisako kobac-free add [END]
    let gensha1 = getters.getByInspectResult(
      INSPECT_TYPE.GENSHA,
      InspectButtonValue.CIRCLE
    );
    let legal1 = getters.getByInspectResult(
      INSPECT_TYPE.LEGAL56,
      InspectButtonValue.CIRCLE
    );
    let line1 = getters.getByInspectResult(2, InspectButtonValue.CIRCLE);
    // 2022-01-31 morisako kobac-free add [START]
    let circleList = gensha1.concat(legal1).concat(line1).map((elm: any, index: number) => {
      return { ...elm, row: index + 1 };
    });
    // 2022-01-31 morisako kobac-free add [END]
    // 2022-01-31 morisako kobac-free mod [START]
    // _list.push(gensha1.concat(legal1).concat(line1));
    _list.push(discountGenshaList1.concat(discountLegalList1).concat(circleList));
    // 2022-01-31 morisako kobac-free mod [END]

    // 2022-01-31 morisako kobac-free add [START]
    let discountGenshaList2 = getters.getByIsDiscount(
      INSPECT_TYPE.GENSHA,
      InspectButtonValue.CROSS
    );
    let discountLegalList2 = getters.getByIsDiscount(
      INSPECT_TYPE.LEGAL56,
      InspectButtonValue.CROSS
    );
    // 2022-01-31 morisako kobac-free add [END]
    let gensha2 = getters.getByInspectResult(
      INSPECT_TYPE.GENSHA,
      InspectButtonValue.CROSS
    );
    let legal2 = getters.getByInspectResult(
      INSPECT_TYPE.LEGAL56,
      InspectButtonValue.CROSS
    );
    let line2 = getters.getByInspectResult(2, InspectButtonValue.CROSS);
    // 2022-01-31 morisako kobac-free add [START]
    let crossList = gensha2.concat(legal2).concat(line2).map((elm: any, index: number) => {
      return { ...elm, row: index + 1 };
    });
    // 2022-01-31 morisako kobac-free add [END]
    // 2022-01-31 morisako kobac-free mod [START]
    // _list.push(gensha2.concat(legal2).concat(line2));
    _list.push(discountGenshaList2.concat(discountLegalList2).concat(crossList));
    // 2022-01-31 morisako kobac-free mod [END]

    // 2022-01-31 morisako kobac-free add [START]
    let discountGenshaList3 = getters.getByIsDiscount(
      INSPECT_TYPE.GENSHA,
      InspectButtonValue.TRIANGLE
    );
    let discountLegalList3 = getters.getByIsDiscount(
      INSPECT_TYPE.LEGAL56,
      InspectButtonValue.TRIANGLE
    );
    // 2022-01-31 morisako kobac-free add [END]
    let gensha3 = getters.getByInspectResult(
      INSPECT_TYPE.GENSHA,
      InspectButtonValue.TRIANGLE
    );
    let legal3 = getters.getByInspectResult(
      INSPECT_TYPE.LEGAL56,
      InspectButtonValue.TRIANGLE
    );
    // 2022-01-31 morisako kobac-free add [START]
    let triangleList = gensha3.concat(legal3).map((elm: any, index: number) => {
      return { ...elm, row: index + 1 };
    });
    // 2022-01-31 morisako kobac-free add [END]
    // 2022-01-31 morisako kobac-free mod [START]
    // _list.push(gensha3.concat(legal3));
    _list.push(discountGenshaList3.concat(discountLegalList3).concat(triangleList));
    // 2022-01-31 morisako kobac-free mod [END]
    return _list;
  },
  listInspectByType: (state: InspectionState, getters) => (
    inspectType: number
  ) => {
    if (inspectType == INSPECT_TYPE.RECOMMEND) {
      let list1 = getters.getByInspectResult(
        inspectType,
        InspectButtonValue.CROSS
      );
      let list2 = getters.getByInspectResult(
        inspectType,
        InspectButtonValue.TRIANGLE
      );
      return list1.concat(list2);
    } else {
      let list1 = getters.getByInspectResult(
        INSPECT_TYPE.GENSHA,
        InspectButtonValue.CROSS
      );
      let list2 = getters.getByInspectResult(
        inspectType,
        InspectButtonValue.CROSS
      );
      let list3 = getters.getByInspectResult(
        INSPECT_TYPE.GENSHA,
        InspectButtonValue.TRIANGLE
      );
      let list4 = getters.getByInspectResult(
        inspectType,
        InspectButtonValue.TRIANGLE
      );
      return list1
        .concat(list2)
        .concat(list3)
        .concat(list4);
    }
  }
};

function updateInspect(state: any, payload: any, onlyDoTenken: boolean) {
  if (payload.sknInspectType != null) {
    let inspectType = payload.sknInspectType;
    if (inspectType == INSPECT_TYPE.INSPECT_LINE) {
      inspectType = 2;
    }
    const i = state.inspect[inspectType].findIndex(
      (item: InspectionItem) =>
        item.sknInspectId != null && item.sknInspectId == payload.sknInspectId
    );

    if (i > -1) {
      if (onlyDoTenken) {
        state.inspect[inspectType][i].doTenken = payload.doTenken;
      } else {
        state.inspect[inspectType][i] = payload;
      }
      return true;
    }
  } else {
    for (let j = 0; j < 3; j++) {
      let isUpdate = updateInspect(
        state,
        {
          ...payload,
          sknInspectType: j,
          sknInspectId: payload.sknUketsukeInspectId
        },
        onlyDoTenken
      );
      if (isUpdate) {
        break;
      }
    }
  }
  return false;
}

export default {
  namespaced: true,
  state: { ...initialState },
  getters,
  mutations,
  actions
};
